export default {
    "lineheight": 8,
    "kerning": -1,
    "characters": {
        "/": require("./-slash.png").default,
        "-": require("./-dash.png").default,
        "+": require("./-plus.png").default,
        "0": require("./0.png").default,
        "1": require("./1.png").default,
        "2": require("./2.png").default,
        "3": require("./3.png").default,
        "4": require("./4.png").default,
        "5": require("./5.png").default,
        "6": require("./6.png").default,
        "7": require("./7.png").default,
        "8": require("./8.png").default,
        "9": require("./9.png").default,
    }
}
